import { createSlice } from '@reduxjs/toolkit';
import {
  initContentCreate,
  IContentCreate,
  getUnitid,
} from './contentCreate-data';

const contentCreateSlice = createSlice({
  name: 'contentCreate',
  initialState: initContentCreate,
  reducers: {
    setBookData: (state, action) => {
      const data = action.payload as IContentCreate['bookData'];
      const chapter_info = data.chapter_info;
      const unitid = getUnitid(chapter_info[0]);
      if (!state.unitid) {
        state.unitid = unitid;
      }
      state.bookData = data;
    },
    setUnitid: (state, action) => {
      const unitid = action.payload as string;
      state.unitid = unitid;
    },
    setConfig_list: (state, action) => {
      const config_list = action.payload.data as IContentCreate['config_list'];
      state.config_list = config_list;
    },

    setActiveGrounp: (state, action) => {
      const activeGrounp = action.payload as IContentCreate['activeGrounp'];
      state.activeGrounp = activeGrounp;
    },
    setActiveGrounpChild: (state, action) => {
      const activeGrounpChild =
        action.payload as IContentCreate['activeGrounpChild'];
      state.activeGrounpChild = activeGrounpChild;
    },
    setBookList: (state, action) => {
      state.bookList = action.payload;
    },
    setActiveAgentInfo: (state, action) => {
      state.activeAgentInfo = action.payload;
    },
    setTemplateGroups: (state, action) => {
      state.templateGroups = action.payload;
    },

    setActiveRuanWenInfo: (state, action) => {
      state.activeRuanWenInfo = action.payload;
    },
    setActiveRuanWenInfoAudio: (state, action) => {
      state.activeRuanWenInfo = {
        ...state.activeRuanWenInfo,
        audio: action.payload,
      };
    },
    setActiveWenbenchenlieList: (state, action) => {
      state.activeWenbenchenlieList = action.payload;
    },
    setActiveKey: (state, action) => {
      state.activeKey = action.payload;
    },
    setIsshowBindDrawer: (state, action) => {
      state.isshowBindDrawer = action.payload;
    },
    setTestAgent: (state, action) => {
      state.testAgent = action.payload;
    },
    setTagList: (state, action) => {
      state.tagList = action.payload;
    },
    setShuxingChangedFlag: (state, action) => {
      state.shuxingChangedFlag = action.payload;
    },
    setGuanliAgentChangeFlag: (state, action) => {
      state.guanliAgentChangeFlag = action.payload;
    },
    setFreshFeedbackFlag: (state, action) => {
      state.freshFeedbackFlag = action.payload;
    },
  },
});

export const {
  setBookData,
  setBookList,
  setUnitid,
  setConfig_list,
  setActiveGrounp,
  setActiveGrounpChild,
  setActiveAgentInfo,
  setTemplateGroups,
  setActiveRuanWenInfo,
  setActiveRuanWenInfoAudio,
  setActiveWenbenchenlieList,
  setActiveKey,
  setIsshowBindDrawer,
  setTestAgent,
  setTagList,
  setShuxingChangedFlag,
  setGuanliAgentChangeFlag,
  setFreshFeedbackFlag,
} = contentCreateSlice.actions;
export default contentCreateSlice.reducer;
